import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import { Send } from '@mui/icons-material';

interface ClassNotificationStatsProps {
  stats?: {
    totalSent: number;
    successCount: number;
    errorCount: number;
  };
}

export function ClassNotificationStats({ stats }: ClassNotificationStatsProps) {
  const total = stats?.totalSent || 0;
  const success = stats?.successCount || 0;
  const error = stats?.errorCount || 0;

  // 3. Calculamos a porcentagem de sucesso (evitando divisão por zero que gera NaN)
  const successPercentage = total > 0 ? Math.round((success / total) * 100) : 0;

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="subtitle1" fontWeight="bold" color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3, alignSelf: 'flex-start' }}>
        <Send color="primary" fontSize="small" /> Status de Notificações
      </Typography>
      
      <Box sx={{ position: 'relative', width: 120, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg viewBox="0 0 36 36" style={{ transform: 'rotate(-90deg)', width: '100%', height: '100%' }}>
          {/* Fundo Cinza */}
          <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#e0e0e0" strokeWidth="4" />
          <path 
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" 
            fill="none" 
            stroke={total > 0 ? "#3b82f6" : "transparent"} // Se não houver envio, esconde o azul
            strokeWidth="4" 
            strokeDasharray={`${successPercentage}, 100`} // 🔥 Aqui a mágica acontece!
          />
        </svg>
        <Box sx={{ position: 'absolute', textAlign: 'center' }}>
          <Typography variant="h5" fontWeight="bold" color="text.primary" lineHeight={1}>
            {successPercentage}%
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10, textTransform: 'uppercase' }}>
            Sucesso
          </Typography>
        </Box>
      </Box>
      
      <Stack direction="row" spacing={3} mt={3}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'primary.main' }} />
          <Typography variant="caption" color="text.secondary">Sucesso ({success})</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'error.main' }} />
          <Typography variant="caption" color="text.secondary">Falha ({error})</Typography>
        </Box>
      </Stack>
    </Paper>
  );
}